import type { TApiErrorCode, TApiErrorLike } from '~/store/types.ts';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const isApiErrorLike = (error: unknown): error is TApiErrorLike => isRecord(error);

export const getErrorCode = (error: unknown): TApiErrorCode | undefined => {
  if (!isApiErrorLike(error)) {
    return undefined;
  }

  return error.response?.data?.errorCode || error.data?.errorCode || error.errorCode;
};
